import { render, staticRenderFns } from "./IconMonoCliente.vue?vue&type=template&id=7847ce90&"
import script from "./IconMonoCliente.vue?vue&type=script&lang=ts&"
export * from "./IconMonoCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports